export default {
    name: 'Manual',
    data() {
        return {
            Email: '',
            Name: '',
            Tel: '',
            EndDate: null
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            var result = await this.$api.getThisDevice();
            this.Email = result.HelperEmail;
            this.Name = result.HelperName;
            this.Tel = result.Phone;
            if (result.Data && result.Data.Contracts && result.Data.Contracts.length > 0) {
                this.EndDate = result.Data.Contracts[result.Data.Contracts.length - 1].EndDate;
            }
        }
    }
}